import React, { useEffect, useState } from 'react'
import firebase from '../firebase'
import {
    Tooltip,
} from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import { withRouter, useLocation } from 'react-router-dom'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import { useTranslation } from 'react-i18next'

const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block',
        position: 'absolute',
        left: 55,
        marginTop: theme.spacing(-4.5),
        [theme.breakpoints.down(300)]: {
            left: 50,
        },
    },
    backButton: {
        '&:hover': {
            color: '#bbb',
        },
    }
})

const BackButton = (props) => {
    const { classes } = props
    const { t } = useTranslation()
    const [isLogged, setIsLogged] = useState(false)
    const location = useLocation()

    useEffect(() => {
        if (firebase.getCurrentUsername()) {
            setIsLogged(true)
        } else {
            setIsLogged(false)
        }
    }, [])

    useEffect(() => {
        if (firebase.getCurrentUsername()) {
          setIsLogged(true)
        } else {
          setIsLogged(false)
        }
      }, [location.pathname])

    const goBack = () => {
        props.history.goBack()
    }

    return (
        <main className={classes.main}>
            {!isLogged ?
                <div></div>
                :
                <Tooltip title={t('goback.label')} aria-label="event done">
                    <KeyboardBackspaceIcon onClick={goBack} className={classes.backButton} />
                </Tooltip>
            }
        </main>
    )
}

export default withRouter(withStyles(styles)(BackButton))